import { useEffect, useRef, useState } from 'react';

const MENU_WIDTH = 240;
const MENU_MAX_HEIGHT = 192;
const GAP = 6;
const SCREEN_PADDING = 8;

const Style = ({ size }) => {
  const [open, setOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const updateMenuPosition = () => {
    if (!buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const estimatedMenuHeight = menuRef.current?.offsetHeight || MENU_MAX_HEIGHT;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const openUp =
      spaceBelow < estimatedMenuHeight + GAP && spaceAbove > spaceBelow;
    let left = rect.left + rect.width / 2 - MENU_WIDTH / 2;
    if (left < SCREEN_PADDING) left = SCREEN_PADDING
    if (left + MENU_WIDTH > window.innerWidth - SCREEN_PADDING)
      left = window.innerWidth - MENU_WIDTH - SCREEN_PADDING;
    const top = openUp
      ? Math.max(SCREEN_PADDING, rect.top - estimatedMenuHeight - GAP)
      : rect.bottom + GAP;
    setMenuPosition({ top, left });
  };

  const handleMenu = () => {
    if (!open) updateMenuPosition();
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!open) return;
    updateMenuPosition();
    const handleClickOutside = (event) => {
      const clickedInsideButton = buttonRef.current?.contains(event.target);
      const clickedInsideMenu = menuRef.current?.contains(event.target);
      if (!clickedInsideButton && !clickedInsideMenu) setOpen(false)
    };
    const handleReposition = () => {updateMenuPosition()};
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('resize', handleReposition);
    window.addEventListener('scroll', handleReposition, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleReposition);
      window.removeEventListener('scroll', handleReposition, true);
    };
  }, [open]);

  useEffect(() => {if (open) updateMenuPosition()}, [open, size]);

  return {
    open,
    menuPosition,
    buttonRef,
    menuRef,
    handleMenu
  };
};

export default Style;
